import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import WebFont from 'webfontloader';
import Contenedor from './elementos/Contenedor';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import InicioSesion from './componentes/InicioSesion';
import RegistroUsuarios from './componentes/RegistroUsuarios';
import {Helmet} from "react-helmet";
import favicon from './imagenes/logo.png';
import {AuthProvider} from './contextos/AuthContext';
import RutaPrivada from './componentes/RutaPrivada';
import Quiz from './componentes/Quiz';
import 'react-photo-view/dist/react-photo-view.css';
import Sesiones from './componentes/Sesiones';
import Membresias from './componentes/Membresias';
import MiCuenta from './componentes/MiCuenta';
import ActivarMembresia from './componentes/ActivarMembresia';
import MisMetas from './componentes/MisMetas';
import { Toaster } from "react-hot-toast";
import PerfilStats from "./componentes/PerfilStats";
import Leaderboard from './componentes/Leaderboard';
import Cofres from './componentes/Cofres';
import BossBattle from './componentes/BossBattle';
import PortalMeta from "./componentes/PortalMeta";
import ComponentePortal
from "./componentes/ComponentePortal";
import TemaPortal
from "./componentes/TemaPortal";
import Onboarding
from "./componentes/Onboarding";
import InicioRouter
from "./componentes/InicioRouter";
import GruposProfesor from "./componentes/GruposProfesor";
import GrupoProfesor from "./componentes/GrupoProfesor";
import EstudianteGrupos from "./componentes/EstudianteGrupos"
import UnirseGrupo from "./componentes/UnirseGrupo";

WebFont.load({
  google: {
    families: ['Work Sans:400,500,700', 'sans-serif']
  }
});

const Index = () => {
  return (
    <>
      <Helmet>
        <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
      </Helmet>

      <AuthProvider>
  <BrowserRouter>
    <Routes>

      {/* Públicas */}
      <Route path="/iniciar-sesion" element={<InicioSesion />} />
      <Route path="/crear-cuenta" element={<RegistroUsuarios />} />
      <Route path="/unirse/:codigo" element={<UnirseGrupo />} />
      
      {/* Privadas */}
      <Route
        path="/*"
        element={
          <RutaPrivada>
            <Contenedor>
              <Routes>
              <Route
	path="/"
	element={
		<InicioRouter />
	}
/>
                <Route
                  path="/onboarding"
                  element={<Onboarding />}
                />
                <Route path="/quiz/:tipo" element={<Quiz />} />
                <Route path="/sesiones" element={<Sesiones />} />
                <Route path="/membresias" element={<Membresias />} />
                <Route path="/mi-cuenta" element={<MiCuenta />} />
                <Route path="/mis-metas" element={<MisMetas />} />
                <Route
                  path="/meta/:codigo"
                  element={<PortalMeta />}
                />
                <Route
                  path="/meta/:codigo/componente/:id"
                  element={<ComponentePortal />}
                />
                <Route
                  path="/meta/:codigo/componente/:componenteId/tema/:temaId"
                  element={<TemaPortal />}
                />
                <Route path="/activar-membresia/:token" element={<ActivarMembresia />} />
                <Route path="/perfil"	element={<PerfilStats />}/>
                <Route path="/leaderboard"	element={<Leaderboard />}/>
                <Route path="/cofres"	element={<Cofres />}/>
                <Route path="/boss"	element={<BossBattle />}/>
                <Route

    path="/profesor/grupos"

    element={<GruposProfesor/>}

/>

<Route

    path="/profesor/grupos/:grupoId"

    element={<GrupoProfesor/>}

/>
<Route

path="/grupos"

element={<EstudianteGrupos/>}

/>
          </Routes>
            </Contenedor>
          </RutaPrivada>
        }
      />

    </Routes>
  </BrowserRouter>
  <Toaster
	position="top-center"
	toastOptions={{
		style: {
			background: "#111827",
			color: "#fff",
			border: "1px solid rgba(255,255,255,0.08)"
		}
	}}
/>

</AuthProvider>
    </>
  );
}

ReactDOM.render(<Index />, document.getElementById('root'));